import { Box, Paper, Grid, Typography } from "@mui/material";
import { useEffect } from 'react';
import { trackPcsOnce } from '../../app/telemetry/portalTelemetry';

export default function PrepaidPaymentSucceed() {
    useEffect(() => {
        trackPcsOnce('PrepaidDisplayed', 'prepaid-displayed', { paymentOption: 'prepaid' });
    }, []);

    return <>
        <Box sx={{ minWidth: "100%" }} component={Paper}>

            <Grid container rowSpacing={4}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%' }}>
                    <Typography variant='h4'>Payment successful</Typography>
                </Grid>

                <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%', marginRight: '2%', marginBottom: '2%' }}>
                    <Typography variant='subtitle1'>
                        Thank you for re-enrolling. Our records indicate payment has already been processed.
                    </Typography>
                </Grid>

            </Grid>
        </Box>
    </>
}
